import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GgInStockReminderAdapter } from './in-stock-reminder.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccGgInStockReminderAdapter implements GgInStockReminderAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  remindUser(productCode: string, email: string, subscriptions: string[]) {
    const url = this.occEndpoints.buildUrl('remindUser', { urlParams: { productCode } });
    return this.http
      .post(url, {
        email,
        subscriptions,
      })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
